import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import { alllanguage } from "../../data/lang/index";
import { Ilanguage } from "../../core/interface/Icommon";
import { actions as paytableGameActions } from "../../gamereducer/paytableGameReducer";
import withMobilePaytableConfiguration from "./configuration/withMobilePaytablePortraitConfiguration";
import { isMobile } from "react-device-detect";
import { actions as behaviourAction } from "../../gamereducer/behaviourReducer";
import { actions as paytableActions } from "../../core/reducers/paytableReducer";


interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;
}

interface IStateToProps {
    [x: string]: any;
}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class MobilePaytablePortrait extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected paytable_ContainerPortrait: _ReactPixi.IContainer | Ref<any>;
    private alllanguage: Ilanguage;

    protected baseContainerHeight: number = 680;
    private minFullHDWidth: number = 1024;
    private HDReadyWidth: number = 1280;
    private fullHDWidth: number = 1920;
    private minFullHDPxRatio: number = 2;
    private constantT1: number = 100;
    private canvasBgImagePage: string = "";
    protected symbolsList: any = [];
    protected ui_mode: any;
    protected displayUI: any;


    constructor(props: IProps) {
        super(props);
        this.app = props.app;

        this.alllanguage = alllanguage;
        this.paytable_ContainerPortrait = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en",
            currentIndex: 1,
            totalSlides: 7,
            leftIndicator: false,
            rightIndicator: false,


        }
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }
        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));



    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    //this method will initialize carousal state according to the page number in the beginning


    //this function will move slide to the left





    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        return true;
    }



    //when any button get clicked, we can get that button's call in this method
    handleEvent = (e: any) => {


    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {

        this.setPaytablePayoutValues();
    }



    //this method will change the state for right button


    componentDidMount() {
        this.addScrollBar();
        this.setPaytablePayoutValues();
    }
    setPaytablePayoutValues() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            let selectedBet = this.props.coinList[this.props.selectedCoin];
            this.props.paytablePayoutArray.forEach((obj: any, index: any) => {
                let symbolId = obj.id;
                let payoutArr = obj.payout;
                for (const key in payoutArr) {
                    let multiplier: any = key
                    let textName: string = `symid_${symbolId}_mul_${Number(key)}`
                    let payoutTxt: any = UIManager.getRef(textName)
                    payoutTxt && UIManager.setText(textName, (Number(payoutArr[key] / 10) * selectedBet).toFixed(2))

                }

            });
        }
    }
    addScrollBar() {
        let paytableContent: any = UIManager.getRef("paytableContentPortrait")
        let gameScrollComponent: any = UIManager.getRef("gameScrollComponentMobPortrait")
        const Scrollbox = require('pixi-scrollbox').Scrollbox
        const scrollbox = new Scrollbox({ boxWidth: 1080, boxHeight: 1400 })

        scrollbox.x = 0;
        scrollbox.y = 300;
        gameScrollComponent && gameScrollComponent.addChild(scrollbox)

        // add a sprite to the scrollbox's content
        const sprite = scrollbox.content.addChild(new PIXI.Sprite(PIXI.Texture.WHITE))
        sprite.width = 800
        sprite.height = 1500
        isMobile && (sprite.alpha = 0.01);
        sprite.tint = 0x131313

        scrollbox.dragScroll = true;
        scrollbox.overflowX = "none";
        // force an update of the scrollbox's calculations after updating the children

        scrollbox.content.addChild(paytableContent);
        // add the viewport to the stage
        scrollbox.update()
        //UIManager.getRef("nakliScroll") && (UIManager.getRef("nakliScroll").x = 145);
    }




    render() {


        return (
            <UIManager id={"mobilePaytableContainerPortrait"} name={"mobilePaytableContainerPortrait"} type={"Container"}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-Paytable-${Math.random()}`} langObj={this.props.langObj}
                            type={i.type}
                            id={i.id} {...i} app={this.app} ClickHandler={this.handleEvent} />)
                }

            </UIManager>
        );
    }


}

export default withPixiApp(connect(
    (state: Pick<IStore, 'paytableState' | 'betPanelState' | 'paytableGameState' | 'basegameState'>): IStateToProps =>
    ({

        showPaytable: state.paytableState.showPaytable,
        //  carouselStart: state.paytableGameState.carouselStart,
        paytablePayoutArray: state.paytableGameState.paytablePayoutArray,
        currentBetIndex: state.basegameState.currentBetIndex,
        betList: state.basegameState.betList,
        selectedCoin: state.betPanelState.selectedCoin,
        coinList: state.betPanelState.coinList,


    }),
    (dispatch: Dispatch): IDispatchToProps => ({

        hidePaytable: (): any => dispatch(paytableActions.hidePaytable()),
        //  startCarousel: (): any => dispatch(paytableGameActions.startCarousel()),
        setWinAmount: (winAmountEmpty: any): any => dispatch(behaviourAction.setWinAmount(winAmountEmpty)),
    }))(withMobilePaytableConfiguration(MobilePaytablePortrait)));